import {
  LOGIN_USER_REQUEST,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  LOGOUT_USER,
  USER_DATA_SUCCESS,
  USER_DATA_FAILURE,
  GET_USER_DATA_REQUEST,
  GET_USER_DATA_SUCCESS,
  USER_NEEDS_TO_RESET_PASSWORD,
  USER_IS_LOGGED_IN_FETCHING_ALL_DATA,
  USER_IS_LOGGED_IN_DATA_FETCHED
} from '../actions/user'
import { SET_CURRENT_ORGANIZATION_ROLES } from '../actions/organization'
import {
  UPDATE_ACCOUNT_REQUEST,
  UPDATE_ACCOUNT_SUCCESS,
  UPDATE_ACCOUNT_FAILURE,
  IS_EDITING_ACCOUNT,
  IS_NOT_EDITING_ACCOUNT
} from '../actions/account'
import {
  ASSIGN_QUEST_TO_USER_SUCCESS,
  UNASSIGN_QUEST_FROM_USER_SUCCESS
} from '../actions/assignment'
import { SET_ACCEPTED_POLICIES_TO_USER } from '../actions/policies'
import { CREATE_COMPILED_QUEST_SUCCESS } from '../actions/review'
import { LOCATION_CHANGE } from 'react-router-redux'

const initialState = {
  token: null,
  userName: null,
  isAuthenticated: false,
  isAuthenticating: false,
  statusText: null,
  questCounts: null,
  isEditingAccount: false,
  isUpdatingAccount: false,
  stats: null,
  isLoading: false,
  userNeedsToResetPassword: false,
  user: null
}

export function user(state = initialState, action) {
  switch (action.type) {
    case LOGIN_USER_REQUEST:
      return Object.assign({}, state, {
        isAuthenticating: true,
        statusText: null,
        stats: null
      })
    case LOGIN_USER_SUCCESS:
      return Object.assign({}, state, {
        isAuthenticating: false,
        isAuthenticated: true,
        token: action.payload.token,
        userName: action.payload.name,
        user: action.payload.user
      })
    case LOGIN_USER_FAILURE:
      return Object.assign({}, state, {
        isAuthenticating: false,
        isAuthenticated: false,
        token: null,
        userName: null,
        statusText: action.payload.statusText
      })
    case LOGOUT_USER:
      return Object.assign({}, state, {
        isAuthenticated: false,
        isAuthenticating: false,
        token: null,
        userName: null,
        user: null,
        statusText: null,
        questCounts: null,
        stats: null
      })
    case USER_DATA_SUCCESS:
      return Object.assign({}, state, {
        questCounts: action.questCounts
      })
    case USER_DATA_FAILURE:
      return Object.assign({}, state, {
        statusText: action.payload.statusText
      })
    case SET_CURRENT_ORGANIZATION_ROLES:
      var user = {}
      Object.assign(user, state.user)
      user.organization_roles = action.roles
      return Object.assign({}, state, {
        user: user
      })
    case UPDATE_ACCOUNT_REQUEST:
      return Object.assign({}, state, {
        isUpdatingAccount: true
      })
    case UPDATE_ACCOUNT_SUCCESS:
      var newUser = {}
      Object.assign(newUser, state.user)
      newUser.photo.url = action.file
      newUser.about = action.about
      return Object.assign({}, state, {
        isUpdatingAccount: false,
        user: newUser
      })
    case UPDATE_ACCOUNT_FAILURE:
      return Object.assign({}, state, {
        isUpdatingAccount: false
      })
    case IS_EDITING_ACCOUNT:
      return Object.assign({}, state, {
        isEditingAccount: true
      })
    case IS_NOT_EDITING_ACCOUNT:
      return Object.assign({}, state, {
        isEditingAccount: false
      })
    case GET_USER_DATA_REQUEST: {
      return Object.assign({}, state, {
        isLoading: true
      })
    }
    case GET_USER_DATA_SUCCESS: {
      return Object.assign({}, state, {
        stats: action.payload.stats,
        isLoading: false
      })
    }
    case ASSIGN_QUEST_TO_USER_SUCCESS: {
      return Object.assign({}, state, {
        stats: {
          ...state.stats,
          assigned_quests_count: action.payload.assignment.assigned_quests_count
        }
      })
    }
    case CREATE_COMPILED_QUEST_SUCCESS: {
      var assignmentCount = state.stats.assigned_quests_count
      if (action.payload.userIsAssignedQuest) {
        assignmentCount = parseInt(assignmentCount) - 1
      }
      return Object.assign({}, state, {
        stats: {
          ...state.stats,
          assigned_quests_count: assignmentCount
        }
      })
    }
    case LOCATION_CHANGE: {
      return Object.assign({}, state, {
        statusText: ''
      })
    }
    case UNASSIGN_QUEST_FROM_USER_SUCCESS: {
      let newAssignedQuestsCount = state.stats.assigned_quests_count
      if (action.assignedToCurrentUser) {
        newAssignedQuestsCount -= 1
      }
      return Object.assign({}, state, {
        stats: {
          ...state.stats,
          assigned_quests_count: newAssignedQuestsCount
        }
      })
    }
    case USER_NEEDS_TO_RESET_PASSWORD: {
      if (action.userNeedsToResetPassword) {
        return Object.assign({}, state, {
          userNeedsToResetPassword: true,
          isLoading: false
        })
      } else {
        let u = {}
        Object.assign(u, state.user)
        u.require_password_change_on_next_login = false
        return Object.assign({}, state, {
          userNeedsToResetPassword: false,
          user: u
        })
      }
    }
    case USER_IS_LOGGED_IN_FETCHING_ALL_DATA: {
      return Object.assign({}, state, {
        userIsLoggedInFetchingAllData: true
      })
    }
    case USER_IS_LOGGED_IN_DATA_FETCHED: {
      return Object.assign({}, state, {
        userIsLoggedInFetchingAllData: false
      })
    }
    case SET_ACCEPTED_POLICIES_TO_USER: {
      const policies = action.payload.policies.split(',')
      const formattedPolicies = policies.reduce(
        (o, value, currentIndex) => ({ ...o, [currentIndex]: value }),
        {}
      )
      return Object.assign({}, state, {
        user: {
          ...state.user,
          policies_acceptance: formattedPolicies
        }
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js